import { Pipe, PipeTransform } from '@angular/core';
import { TaxRate, AppliedTax } from '@galaxy/billing';

@Pipe({
  name: 'taxDescription',
})
/**
 * @param tax {TaxRate | AppliedTax} the tax object
 * @param showLongDescription {string} whether the long form description should be shown
 * @returns {string} returns the human readable tax description
 */
export class TaxDescriptionPipe implements PipeTransform {
  transform(tax: TaxRate | AppliedTax, showLongDescription?: boolean): string {
    if (!tax) {
      return '';
    }
    return !!tax.description && showLongDescription
      ? `${tax.name} - ${tax.description} (${tax.percentage}%)`
      : `${tax.name} (${tax.percentage}%)`;
  }
}
